// One animation cycle moves past one copy of the methods, not both copies.
export function expertMarqueeDurationSeconds(methodCount: number): number {
  return Math.max(0, methodCount) * 10;
}
